import { render, staticRenderFns } from "./ContractHead.vue?vue&type=template&id=27625794&"
import script from "./ContractHead.vue?vue&type=script&lang=js&"
export * from "./ContractHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports